/**
 * Copyright 2020 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */

import InfoToolTip from '@/components/AZCustomComponent/InfoToolTip';
import cx from 'classnames';
import styles from './styles.module.scss';

type CertonaTitleWithTooltipProps = {
  title: string;
  tooltipTitle: string;
  tooltipBody: string;
  tooltipPlacement?: 'top' | 'bottom' | 'left' | 'right';
  tooltipStrategy?: 'absolute' | 'fixed';
  tooltipPopperClass?: string;
  tooltipHeaderTag?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'div' | 'span';
  className?: string;
};

type CertonaTitleWithoutTooltipProps = {
  title: string;
  tooltipTitle?: never;
  tooltipBody?: never;
  tooltipPlacement?: never;
  tooltipStrategy?: never;
  tooltipPopperClass?: never;
  tooltipHeaderTag?: never;
  className?: string;
};

type CertonaTitleProps = CertonaTitleWithTooltipProps | CertonaTitleWithoutTooltipProps;

export const CertonaTitle = ({
  title,
  tooltipTitle,
  tooltipBody,
  tooltipPlacement = 'top',
  tooltipStrategy,
  tooltipPopperClass,
  tooltipHeaderTag = 'div',
  className,
}: CertonaTitleProps) => {
  return (
    <>
      <h2 className={cx(styles.title, className)} data-testid="dynamic-content">
        {title}
        {tooltipTitle && tooltipBody && (
          <InfoToolTip
            header={tooltipTitle}
            body={tooltipBody}
            placement={tooltipPlacement}
            strategy={tooltipStrategy}
            headerTag={tooltipHeaderTag}
            classes={{ popper: tooltipPopperClass }}
          />
        )}
      </h2>
      <div className={styles.separator} />
    </>
  );
};
